export const INIT = 'app/ActionTemplatePage/INIT';
export const INIT_SUCCESS = 'app/ActionTemplatePage/INIT_SUCCESS';
export const INIT_FAILED = 'app/ActionTemplatePage/INIT_FAILED';

interface InitActionTemplate {
  type: typeof INIT;
}
interface InitSuccessActionTemplate {
  type: typeof INIT_SUCCESS;
}
interface InitFailedActionTemplate {
  type: typeof INIT_FAILED;
  error: any;
  errorCode?: number;
}

const initActionTemplate = (id?: string) => ({
  type: INIT,
  id,
});
const initSuccessActionTemplate = () => ({
  type: INIT_SUCCESS,
});
const initFailedActionTemplate = (error: any, errorCode?: any) => ({
  type: INIT_FAILED,
  error,
  errorCode,
});

export {
  InitActionTemplate,
  InitSuccessActionTemplate,
  InitFailedActionTemplate,
  initActionTemplate,
  initSuccessActionTemplate,
  initFailedActionTemplate,
};
